export const addVideoConstants = {
     ControlIds: {
    MUX_VIDEO_LINK: "muxVideoLink",
    TITLE: "title",
    INSTRUCTOR: "instructor",
    DESCRIPTION: "description",
    SHORT_DESCRIPTION: "shortDescription",
    MUX_TRAILER_LINK: "muxTrailerLink",
    TRAILER_DURATION: "trailerDuration",
    DURATION: "duration",
    CATEGORY_ID: "CategoryId",
    VIDEO_LEVEL: "videoLevel",
    TAGS: "tags",
    KEYWORDS: "keywords",
    PRODUCTS: "products",
    RELEASE_DATE_TIME: "releaseDateTime",
    TIME_ZONE: "timeZone"
  },
    VideoLevels: {
        BEGINNER: "Beginner",
        INTERMEDIATE: "Intermediate",
        ADVANCED: "Advanced",
    }
}